import { setGtagConsent } from './gtag';

type ConsentPayload = {
  categories: Array<'performance'>;
};

declare global {
  interface Window {
    __racemapUserConsent?: ConsentPayload;
  }
}

function getRacemapIframes(): Array<HTMLIFrameElement> {
  return Array.from(document.querySelectorAll<HTMLIFrameElement>('iframe')).filter((frame) => {
    if (!frame.src) return false;
    try {
      const url = new URL(frame.src, window.location.href);
      return url.hostname === 'racemap.com' || url.hostname.endsWith('.racemap.com');
    } catch {
      return false;
    }
  });
}

export function applyTrackingConsent(analyticsGranted: boolean): void {
  const payload: ConsentPayload = {
    categories: analyticsGranted ? ['performance'] : [],
  };
  window.__racemapUserConsent = payload;

  setGtagConsent(analyticsGranted);

  const iframes = getRacemapIframes();
  iframes.forEach((frame) => {
    if (!frame.src) return;
    try {
      const origin = new URL(frame.src, window.location.href).origin;
      frame.contentWindow?.postMessage(
        { type: 'racemap-cookie-consent', consent: payload },
        origin,
      );
    } catch {
      // ignore malformed iframe src
    }
  });
}
